'use client'

import { Box, Typography } from '@mui/material'
import { Link } from '@assets-components'
import { Icon, Image } from '@media-components'
import type { StandardCardData } from '@components/common'
import { getStyles } from '@utils/styles'
import defaultStyles from './styles'

const DEFAULT_CTA_LABEL = 'View Service'

type SearchServiceCardProps = StandardCardData & {
  ctaLabel?: string
}

export function SearchServiceCard({
  title,
  description,
  href,
  imageData,
  actionButtonData,
  ctaLabel: ctaLabelProp,
}: SearchServiceCardProps) {
  const styles = getStyles(defaultStyles)
  const ctaLabel =
    ctaLabelProp ||
    (typeof actionButtonData?.children === 'string'
      ? actionButtonData.children
      : DEFAULT_CTA_LABEL)
  const isLink = Boolean(href)

  return (
    <Box
      {...styles('card')}
      {...(isLink
        ? {
            component: Link,
            href,
          }
        : {})}
    >
      <Box {...styles('content')}>
        <Box {...styles('copy')}>
          {title ? (
            <Typography
              variant="body1.600"
              component="h3"
              color="text.primary"
              {...styles('title')}
            >
              {title}
            </Typography>
          ) : null}
          {description ? (
            <Typography
              variant="body2.500"
              color="text.secondary"
              {...styles('description')}
            >
              {description}
            </Typography>
          ) : null}
        </Box>
        {isLink ? (
          <Typography
            className="search-service-cta"
            variant="body2.700"
            color="text.primary"
            {...styles('cta')}
          >
            {ctaLabel}
            <Icon
              iconName="ArrowRight"
              colorValues="text.primary"
              fontSize="extraSmall"
              aria-hidden="true"
            />
          </Typography>
        ) : null}
      </Box>
      {imageData ? (
        <Image
          {...imageData}
          {...styles('image')}
          alt={imageData.alt || title}
        />
      ) : null}
    </Box>
  )
}
